<template>
  <div class="">
    <div class="seachBox">
      <div class="seachList">
        <span class="name">日期选择：</span>
        <a-range-picker
          class="seachs seachs-time"
          v-model="search.date"
          :disabledDate="disabledDate"
          allowClear
          :showTime="false"
          format="YYYY-MM-DD"
        />
      </div>
      <div class="seachList">
        <span class="name">客户名称：</span>
        <a-input placeholder=" " class="seachs" v-model="search.name" />
      </div>
      <div class="seachList" style="padding-left: 20px;">
        <a-button type="primary" class="top_btn" @click="getList()"
          >搜索</a-button
        >
        <a-button class="top_btn" @click="empty">重置</a-button>
      </div>
    </div>
    <p>
      现阶段使用AI优化合计
      <span style="color: #1890ff;">{{ ai_optimize_zong }}</span>
      张，使用AI抠图合计
      <span style="color: #1890ff;">{{ ai_cutout_zong }}</span>
      张；使用AI视频生成合计<span style="color: #1890ff;">{{ ai_video_zong }}</span>
      分钟；自定义分割使用量<span style="color: #1890ff;">{{ segmentation_zong }}</span>分钟
    </p>

    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="pagination"
      rowKey="id"
      @change="handleChange"
    >
    </a-table>
  </div>
</template>

<script>
import API from "./api";
import moment from "moment";
import { changStatus, removeById, orderList } from "../../../utils/utils";
// sorter: true,

const fdate = () => {
  let nowdate = new Date();
  let y = nowdate.getFullYear();
  let m = nowdate.getMonth() + 1;
  let d = nowdate.getDate();
  return y + "-" + m + "-" + d;
};
const nowdate = () => {
  let nowdate = new Date();
  nowdate.setMonth(nowdate.getMonth() - 1);
  let y = nowdate.getFullYear();
  let m = nowdate.getMonth() + 1;
  let d = nowdate.getDate();
  return y + "-" + m + "-" + d;
};
const columns = [
  {
    title: "客户名称",
    key: "name",

    ellipsis: true,
    dataIndex: "name",
  },
  {
    title: "AI优化张数",
    key: "ai_optimize_num",
    ellipsis: true,
    dataIndex: "ai_optimize_num",
  },
  {
    title: "AI抠图张数",
    key: "ai_cutout_num",
    ellipsis: true,
    dataIndex: "ai_cutout_num",
  },
  {
    title: "AI视频使用量",
    key: "ai_video_time",
    ellipsis: true,
    dataIndex: "ai_video_time",
  }, {
    title: "自定义分割使用量",
    key: "segmentation_time",
    ellipsis: true,
    dataIndex: "segmentation_time",
  },
];
export default {
  name: "index",
  data() {
    return {
      disabledDate(current) {
        // return current && current <moment().subtract(1,"days");//当天之前的不可选，不包括当天
        return current && current > moment().endOf("day");
      },
      statistics_total_price: "",
      loading: true,
      data: [],
      selectedRowKeys: [], // Check here to configure the default column
      columns,
      statistics_date: [],
      search: {
        name: "",
        date: [],
      },
      seachList: {
        online_status: [],
        site_type_list: [],
      },
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
      },
      ai_cutout_zong: "",
      ai_optimize_zong: "",
      ai_video_zong:'',
      segmentation_zong:'',
      // pagination: {
      //     pageNo: 1,
      //     pageSize: 20, // 默认每页显示数量
      //     onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
      //     onChange: this.getList.bind(this), //点击页码事件
      //     total: 0, //总条数
      //     current: 0,
      //     size: "small",
      //     showTotal: total => `共 ${total} 条`,
      //     showQuickJumper: true
      // },
    };
  },
  created() {
    this.$store.state.adminleftnavnum = "/DataStatistics/AiImgBank"; //设置左侧导航2-2 active
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
    statisticsDate() {
      let dataArr = [];
      if (this.statistics_date.length > 0) {
        dataArr[0] = moment(this.statistics_date[0]).format("YYYY-MM-DD");
        dataArr[1] = moment(this.statistics_date[1]).format("YYYY-MM-DD");
      }
      return dataArr;
    },
  },

  methods: {
    moment,
    empty() {
      this.search = { name: "", date: [] };
      this.getList(1);
    },
    getList(page) {
      this.loading = true;
      if (this.search.date.length > 0) {
        this.search.date[0] = moment(this.search.date[0]).format("YYYY-MM-DD");
        this.search.date[1] = moment(this.search.date[1]).format("YYYY-MM-DD");
      }
      let seachData = JSON.parse(JSON.stringify(this.search));
      API.service.GET_LIST({ page: page || 1, ...seachData }).then((res) => {
        this.data = res.data.data.data;
        this.ai_cutout_zong = res.data.data.ai_cutout_zong;
        this.ai_optimize_zong = res.data.data.ai_optimize_zong;
        this.ai_video_zong = res.data.data.ai_video_zong;
        this.segmentation_zong = res.data.data.segmentation_zong;

        this.page = page || 1;
        this.pagination.total = res.data.data.total;
        this.pagination.pageSize = res.data.data.per_page;
        this.pagination.current = res.data.data.current_page;
        this.selectedRowKeys = [];
        this.loading = false;
      });
    },
    // getBtnGroup(){
    //     API.service.GET_BTN().then(res=>{
    //         this.seachList.groupList = res.data.data.group
    //     })
    // },
    // getBtnList(value){
    //     let group_id = value;
    //     this.seachList.btnList=[]
    //     this.search.btn_id = undefined
    //     API.service.GET_BTN({'group_id':group_id}).then(res=>{
    //         this.seachList.btnList = res.data.data.btn
    //     })
    // },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onChangeTime(date, dateString, type) {
      this.type = date;
      dateString[0] = moment(dateString[0]).format("YYYY-MM-DD");
      dateString[1] = moment(dateString[1]).format("YYYY-MM-DD");
      let dateStrings = `${dateString[0]}~${dateString[1]}`;
      if (dateString[0] == "Invalid date") {
        dateStrings = "";
      }
      this.search[type] = dateStrings;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  mounted() {
    // this.statistics_date=[nowdate(),fdate()]
    // this.search["date"] = [nowdate(),fdate()]
    this.getList();
    // this.getBtnGroup()
  },
};
</script>
<style scoped>
.inputs {
  display: inline-block;
  width: 70px;
}
.search-group {
  float: right;
}
.search-group .ant-input {
  width: 200px;
  margin: 0 8px 0 0;
}
.button-group {
  float: left;
}
#list_order {
  width: 50px;
}
.top .flex {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 16px;
  box-sizing: border-box;
  width: 60%;
  margin-bottom: 20px;
}
.seachBox {
  display: flex;
}
.seachBox .seachList {
  flex-wrap: nowrap;
  display: flex;
  width: 20%;
  margin: 5px 0;
}
/*.seachs-time{min-width: 220px;}*/
.seachBox .seachList .name {
  white-space: nowrap;
}
</style>
